import Dialog from '@/global/guides/Dialog'
import { hasPermission } from '@/hooks/useBackendMenu'
import { ajustes } from '@/service/api'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'
import { useRelatoriosAjustesImpressosOutletContext } from './RelatoriosImpressos'

export default function ExcluirRelatorioAjuste() {
    const { hash } = useParams()
    const { data } = useRelatoriosAjustesImpressosOutletContext()

    if (!hash) return null
    const relatorio = data.find(r => r.hash === hash)
    if (!relatorio) return null

    async function handleSubmit() {
        return ajustes.impressos
            .delete(`pdf/${hash}`)
            .then(() => {
                ajustes.impressos.invalidateQueries()
                toast.success('Relatório excluído com sucesso!')
            })
            .catch(e => {
                toast.error(e.message)
            })
    }

    return (
        <Dialog.Root
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'AssinaturaEletrônicaDeAjustes'])}
            width="auto"
            height="auto"
        >
            <Dialog.Title>
                Tem certeza que deseja excluir o relatório de ajustes de ponto?
            </Dialog.Title>
            <Dialog.Content dividers>
                {relatorio.assinadoEm
                    ? 'O relatório já foi assinado e se for excluído, será necessário gerar um novo para assinatura.'
                    : 'O relatório ainda não foi assinado mas outro poderá ser gerado para assinatura.'}
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton color="error" closeOnSubmit>
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
